import { demoTickerBlock } from "@/lib/content-blocks-data";
import { ScrollingTickerSection } from "./scrolling-ticker-section";

export function MarqueeBand() {
  return <ScrollingTickerSection block={demoTickerBlock} />;
}
